import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { objectPopupScreenService } from 'src/app/shared/services/object-popup-screen';

@Component({
    selector: 'app-dropdown-cell-renderer',
    template: `
 <!-- <mat-form-field appearance="fill"> -->
  <!-- <mat-label>is parent</mat-label> -->
  <form [formGroup]="dropdownForm">
    <select style="border: none; width: 100%; height: 100%; background-color: transparent;" formControlName="selectedOption" (change)="onValueChange()" [(ngModel)]="selectedValue" >
      <option *ngFor="let option of valueObj" [value]="option.val">
        {{ option.val }}
      </option>
    </select>
  </form>
<!-- </mat-form-field> -->
  `,
    standalone: false
})
export class DropdownCellRendererComponent implements ICellRendererAngularComp {

  @Output() valueChanged = new EventEmitter<string>(); // Event emitter for selected value
  value: string;
  params: any;
  valueChange: any;
  selectedValue = "No";
  valueObj = [{ val: "Yes" }, { val: "No" }]
  dropdownForm: FormGroup;
  constructor(public objectSvc: objectPopupScreenService) { }

  agInit(params: any): void {
    this.selectedValue = "No";
    console.log(this.selectedValue)
    console.log(params.data.isParent);

    this.selectedValue = params.data.isParent;
    this.params = params
    console.log(params)
    console.log(this.selectedValue)
    this.dropdownForm = new FormGroup({
      selectedOption: new FormControl("", [])
    })
  }

  refresh(params: any): boolean {
    console.log(params);
    this.selectedValue = params.data.isParent;
    return true;
  }



  onValueChange(): void {

    console.log("onvalue change ==> " + this.selectedValue)
    console.log(this.params.data)
            
    let x = this.params.edit(this.selectedValue, this.params.data.id, this.params);



    console.log("value of X is ", x)
    if (x == "No") {

      this.selectedValue = "No";
      console.log("***********************" + this.selectedValue);
      // this.refresh("No")
      this.dropdownForm.get("selectedOption").setValue('No')
      this.params.data.level=null;
    } this.params.data[this.params.column.colId] = this.selectedValue; // Update cell value
    if(x=="Yes"){
  this.params.data.level="1"; // set the level for parent object always as 1
    }  
    this.params.api.refreshCells({ rowNodes: [this.params.node], force: true }); // Refresh cell

  }


}
